import { Image as ImageIcon, X } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { ProductFormValues } from '../types';

interface ProductImageEditorProps {
    form: UseFormReturn<ProductFormValues>;
    fields: any[];
    onRemove: (index: number) => void;
    onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAddClick: () => void;
    imageInputRef: React.RefObject<HTMLInputElement | null>;
    onOpenLightbox: (images: any[], index: number) => void;
}

export function ProductImageEditor({
    fields,
    onRemove,
    onUpload,
    onAddClick,
    imageInputRef,
    onOpenLightbox,
}: ProductImageEditorProps) {
    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                รูปภาพสินค้า
            </label>

            <input
                ref={imageInputRef}
                type="file"
                accept="image/*"
                multiple
                onChange={onUpload}
                className="sr-only"
            />

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 lg:gap-4">
                {fields.map((field, index) => (
                    <div key={field.id} className="relative group">
                        <img
                            src={field.preview}
                            alt={`Product ${index + 1}`}
                            className="w-full h-24 lg:h-32 object-cover rounded-lg border border-stone-300
                       dark:border-gray-600 cursor-pointer
                       hover:opacity-80 hover:border-yellow-400
                       transition-all duration-200"
                            onClick={() => onOpenLightbox(fields, index)}
                            title="คลิกเพื่อดูรูปภาพขนาดเต็ม"
                        />
                        <button
                            type="button"
                            onClick={() => onRemove(index)}
                            className="absolute top-1 lg:top-2 right-1 lg:right-2 bg-red-500 text-white
                       p-1.5 lg:p-1 rounded-full
                       opacity-100 lg:opacity-0 group-hover:opacity-100
                       transition-opacity z-10 touch-target"
                        >
                            <X className="w-3 h-3 lg:w-4 lg:h-4" />
                        </button>
                    </div>
                ))}

                <button
                    type="button"
                    onClick={onAddClick}
                    className="flex h-24 lg:h-32 w-full cursor-pointer flex-col items-center justify-center
                   rounded-lg border-2 border-dashed border-stone-300
                   text-center text-xs lg:text-sm text-stone-600
                   transition-all duration-200
                   hover:border-yellow-400 hover:bg-yellow-50/50
                   active:scale-[0.98]
                   focus:outline-none focus:ring-2 focus:ring-yellow-500
                   dark:border-gray-600 dark:text-gray-400 dark:hover:bg-gray-700/50
                   touch-target"
                    aria-label="เพิ่มรูปสินค้า"
                >
                    <ImageIcon className="w-6 h-6 lg:w-8 lg:h-8 text-stone-400 dark:text-gray-500 mb-1 lg:mb-2" />
                    <span>เพิ่มรูป</span>
                </button>
            </div>
        </div>
    );
}
